/**
 * Dependencies
 */

import { styled } from '@material-ui/styles';

/**
 * Define style
 */

const HeaderH1 = styled('h1')({
  textAlign: 'center',
  padding: '40px 0px 0px 0px',
  margin: '0px',
});

/**
 * Export style
 */

export default HeaderH1;
